import angular from "angular";

export class UserRestService implements qpmn.user.rest.account.IUserRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    public getUserInfo(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.account.IUserInfo>> {
        return this.$rest.http<qpmn.user.model.domain.account.IUserInfo>("userRestService", "getUserInfo");
    }

    public saveUserInfo(userInfo: qpmn.user.model.domain.account.IUserInfo): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("userRestService", "saveUserInfo", userInfo);
    }

    public changePassword(oldPassword: string, password: string): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("userRestService", "changePassword", {
            oldPassword: oldPassword,
            password: password
        });
    }

    public modifyEmail(emailAddress: string): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("userRestService", "modifyEmail", {
            emailAddress: emailAddress
        })
    }

    public mailValidation(token: string): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("userRestService", "mailValidation", {
            token: token
        })
    }
}